import { observable, action } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import {
  FlightsFlexibleSearch,
  FlightsTripType,
  FlightsFlexSearchResults,
  FlightsFlexibleSearchResultCellTheme
} from '__generated__/api';
import FlexibleSearchResponse = FlightsFlexibleSearch.FlexibleSearchResponse;

const emptyCellState = {
  accessibility: {},
  valueText: '',
  theme: '' as FlightsFlexibleSearchResultCellTheme,
  journeyDate: '',
  summary: ''
};

export class FlexibleSearchResultsStore extends Store {
  @observable public loading: boolean;
  @observable public isExpandoOpened: boolean;
  @observable public flexibleSearchResponse?: FlexibleSearchResponse;
  @observable public tripType: FlightsTripType;
  @observable public initialState: FlightsFlexSearchResults.Fragment;
  @observable public selectedCell: FlightsFlexSearchResults.Fragment;
  @observable public showGridFlag: boolean;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public clear(): void {
    this.hydrate(FlexibleSearchResultsStore.DEFAULTS);
  }

  @action
  public updateInitialState(cell: FlightsFlexSearchResults.Fragment): void {
    this.initialState = cell;
  }

  @action
  public updateSelectedCell(cell: FlightsFlexSearchResults.Fragment): void {
    this.selectedCell = cell;

    if (!this.initialState.journeyDate) {
      this.updateInitialState(cell);
    }
  }

  public resetLoadedData(): void {
    if (this.flexibleSearchResponse) {
      this.flexibleSearchResponse.resultsGrid = null;
      this.flexibleSearchResponse.analytics = null;
      this.flexibleSearchResponse.titleAccessibility = null;
    }
    this.showGridFlag = true;
    this.loading = true;
    this.initialState = emptyCellState as FlightsFlexSearchResults.Fragment;
    this.selectedCell = emptyCellState as FlightsFlexSearchResults.Fragment;
  }
}

FlexibleSearchResultsStore.DEFAULTS = {
  flexibleSearchResponse: {
    analytics: null,
    resultsGrid: {},
    title: null,
    subTitle: null,
    searchTriggerAction: null,
    flexGridType: null,
    titleAccessibility: null,
    dismissGridAccessibility: null,
    coverageAnalytics: null,
    coverageNotValidAnalytics: null,
    departureLegend: null,
    gridTrigger: null
  },
  loading: true,
  isExpandoOpened: false,
  tripType: null,
  initialState: emptyCellState,
  selectedCell: emptyCellState,
  showGridFlag: true
};
